import {WidgetConfig} from "controls/designer/features/widgets/widgetConfig";
import {AntSelectOption} from "controls/react/ant/antSelect";
import {MetricConfiguration} from "areas/metrics/components/MetricSelector/types";
import {ColorDescription} from "components/HighchartsWrapper";
import { i18n } from "core/localization";
import {LabelOptions} from "areas/metrics/components/LabelOptionsEditor/types";


export type CompassWidgetConfig = WidgetConfig & {
	metric: MetricConfiguration
	minValue: number
	maxValue: number
	appearance: {
		type: CompassWidgetAppearanceType,
		ticksCount: number
		paneBackgroundColor: ColorDescription,
		indicatorColor: string
		axisColor: string
		invertDial: boolean
		legendTemplate: string[]
		tooltipTemplate: string[]
		labels: {
			direction: LabelOptions,
			legend: LabelOptions,
			tick: LabelOptions,
			value: LabelOptions,
		}
	}
}

export enum CompassWidgetAppearanceType {
	Compass = 'compass',
	Generic = 'generic',
	Radial = 'radial'
}

let appearanceOptions: AntSelectOption[]
export function getCompassWidgetAppearanceOptions(){
	if(appearanceOptions == null){
		appearanceOptions = [{
			label: i18n('Compass'),
			value: CompassWidgetAppearanceType.Compass
		},{
			label: i18n('Generic'),
			value: CompassWidgetAppearanceType.Generic
		},{
			label: i18n('Radial'),
			value: CompassWidgetAppearanceType.Radial
		}]
	}

	return appearanceOptions
}
